<div class="flex justify-center items-center">
  <div
    class="my-5 w-full max-w-lg bg-white rounded-lg border border-border-100"
  >
    <div class="px-6 py-4 border-b border-border-100">
      <h1 class="text-lg font-semibold text-text-900">
        {{
          info.beneficiaryHasProcedures
            ? 'Resumo do agendamento'
            : 'Resumo da compra'
        }}
      </h1>
    </div>

    <div class="px-16">
      <div class="py-4 border-b border-border-100">
        <div class="flex gap-4 items-center mb-3">
          <img src="person-icon.svg" alt="User Icon" class="w-8 h-8" />
          <h2 class="text-lg font-semibold text-text-950">Cliente</h2>
        </div>

        <div class="mb-3 ml-12">
          <span class="block text-xs text-text-900">Nome</span>
          <p class="text-sm font-semibold text-text-900">{{ user.name }}</p>
        </div>

        <div class="mb-3 ml-12">
          <span class="block text-xs text-text-900">CPF</span>
          <p class="text-sm font-semibold text-text-900">{{ user.cpf }}</p>
        </div>

        <div class="ml-12">
          <span class="block text-xs text-text-900">Endereço</span>
          <p class="text-sm font-semibold text-text-900">
            {{ getUserCompleteAddress() }}
          </p>
        </div>
      </div>
    </div>

    <div class="px-16">
      <div class="py-4 border-b border-border-100">
        <div class="flex gap-4 items-center mb-3">
          <img src="physician-icon.svg" alt="Dentist Icon" class="w-8 h-8" />
          <h2 class="text-lg font-semibold text-text-950">Dentista</h2>
        </div>

        <div class="ml-12">
          <p class="text-sm font-semibold text-text-950">
            {{ physician.physicianName }}
          </p>
          <p class="mb-2 text-sm text-text-700">
            CRO {{ physician.physicianCro }}
          </p>
        </div>
      </div>
    </div>

    <div class="px-16 py-4">
      <div class="flex gap-4 items-center mb-3">
        <img src="clock-icon.svg" alt="Clock Icon" class="w-8 h-8" />
        <h2 class="text-lg font-semibold text-text-950">Agendamento</h2>
      </div>
      <div class="ml-12">
        <p class="text-sm font-semibold text-text-900">
          {{ appointmentDateTime?.date | date: 'dd/MM/yyyy' }} às
          {{ appointmentDateTime?.time | date: 'HH:mm' }}
        </p>
        <p class="mt-2 text-sm text-text-700">
          {{ getPhysicianCompleteAddress() }}
        </p>
      </div>
    </div>

    @if (!info.beneficiaryHasProcedures) {
      <div class="px-16 py-4">
        <div class="flex gap-4 items-center mb-3">
          <img src="attach-money.svg" alt="Money Icon" class="w-8 h-8" />
          <h2 class="text-lg font-semibold text-text-950">Procedimentos</h2>
        </div>

        <div class="flex flex-col gap-3 ml-12">
          <div class="pb-4 border-b border-border-100">
            @for (
              procedure of selectedProcedures;
              track idx;
              let idx = $index
            ) {
              <div class="flex gap-2 justify-between mb-1">
                <span class="text-sm text-text-900">
                  {{ procedure.procedureName }}
                </span>
                <span class="text-sm text-text-900">
                  {{ convertToBrazilianCurrency(procedure.procedurePrice) }}
                </span>
              </div>
            }
          </div>

          <div class="mt-3">
            <div class="flex justify-between mb-2 text-sm">
              <span class="text-text-900">Total dos procedimentos</span>
              <span class="text-text-700">
                R$ {{ proceduresTotal | number: '1.2-2' }}
              </span>
            </div>

            <div class="flex justify-between items-center mb-2 text-sm">
              <span class="text-text-900">Total de descontos</span>
              <div class="flex gap-2 items-center">
                <span
                  class="px-2 py-1 text-xs font-medium text-white rounded bg-background-700"
                >
                  {{ discountPercent | number: '1.0-2' }}%
                </span>
                <span class="font-medium text-red-600">
                  -R$ {{ discountTotal | number: '1.2-2' }}
                </span>
              </div>
            </div>

            <div class="flex justify-between mb-2 text-sm">
              <span class="text-text-900">Serviço</span>
              <span class="text-text-700">
                R$ {{ serviceTax | number: '1.2-2' }}
              </span>
            </div>

            <div class="my-3 w-full h-px bg-border-100"></div>

            <div
              class="flex justify-between text-base font-semibold text-text-900"
            >
              <span>Total</span>
              <span> R$ {{ finalPrice | number: '1.2-2' }} </span>
            </div>
          </div>
        </div>
      </div>
    }

    <div class="px-14 py-8">
      <div class="grid grid-cols-2 gap-3 justify-end">
        <app-button
          label="Voltar"
          buttonType="secondary"
          buttonAction="default"
          (handleClick)="goBack()"
          fullSize="true"
        ></app-button>
        <app-button
          [label]="
            info.beneficiaryHasProcedures ? 'Agendar consulta' : 'Gerar link'
          "
          buttonType="solid"
          buttonAction="default"
          (handleClick)="
            info.beneficiaryHasProcedures ? createAppointment() : generateLink()
          "
          fullSize="true"
        ></app-button>
      </div>
    </div>
  </div>
</div>

<app-modal
  [visible]="displayModal"
  (visibleChange)="displayModal = $event"
  (close)="closeModal()"
  [modal]="true"
  [width]="'548px'"
>
  @if (info.beneficiaryHasProcedures) {
    <ng-container *ngTemplateOutlet="modalCreateAppointment" />
  } @else {
    <ng-container *ngTemplateOutlet="modalGenerateLink" />
  }
</app-modal>

<ng-template #modalGenerateLink>
  <div class="flex flex-col items-center p-5 text-center">
    <img src="meu-plus-sucess.svg" alt="Sucesso" class="mb-4 w-44 h-44" />

    <h2 class="my-6 text-3xl font-bold text-black">Link gerado com sucesso!</h2>
    <p class="text-black">
      O link de pagamento foi enviado para o cliente, e assim que ele efetuar o
      pagamento, receberá o QR Code automaticamente.
    </p>

    <div class="grid grid-cols-2 gap-3 mt-8 w-full">
      <app-button
        label="Copiar link"
        buttonType="secondary"
        buttonAction="default"
        (handleClick)="copyLink()"
        fullSize="true"
      />
      <app-button
        label="Concluir"
        buttonType="solid"
        buttonAction="default"
        (handleClick)="closeModal()"
        fullSize="true"
      />
    </div>
  </div>
</ng-template>

<ng-template #modalCreateAppointment>
  <div class="flex flex-col items-center p-5 text-center">
    <img src="meu-plus-sucess.svg" alt="Sucesso" class="mb-4 w-44 h-44" />

    <h2 class="my-6 text-3xl font-bold text-black">
      Consulta agendada com sucesso!
    </h2>
    <p class="text-black">
      Um e-mail de confirmação foi enviado para o cliente.
    </p>

    <div class="flex justify-center mt-8 w-full">
      <app-button
        label="Concluir"
        buttonType="solid"
        buttonAction="default"
        (handleClick)="closeModal()"
        fullSize="true"
      />
    </div>
  </div>
</ng-template>
